<ef-loading-container [observables]="[statusData$, drStatus$, funding$]"></ef-loading-container>
<ef-dashboard-presenter
    [selectedProcesses]="selectedProcesses"
    [processes]="processes"
    [dashboardSettings]="dashboardSettings$ | async"
    [accrualData]="accrualData$ | async"
    [statusData]="statusData$ | async"
    [drStatus]="drStatus$ | async"
    [funding]="funding$ | async"
    [contracts]="contracts$ | async"
    [companySettings]="companySettings$ | async"
    [user]="user$ | async"
    [users]="users$ | async"
    [userRoles]="userRoles$ | async"
    [roleID]="roleID"
    [adminMsg]="adminMsg"
    [mgrMsg]="mgrMsg"
    [userMsg]="userMsg"
    [announcement]="announcement"
    [announcementAdmin]="announcementAdmin"
    [showPMStatusBlock]="showPMStatusBlock"
    [showSupervisorStatusBlock]="showSupervisorStatusBlock"
    (GetFunding)="onGetFunding($event)"
    (GetDRStatus)="onGetDRStatus($event)"
    (GetAccrualData)="onGetAccrualData($event)"
    (GetDirectReports)="onGetDirectReports($event)"
    (UpdateDashboardSettings)="onUpdateDashboardSettings($event)"
></ef-dashboard-presenter>
